import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import OnePageLayout from "../../components/layout/OnePageLayout";
import {
  Button,
  ButtonXS,
  Content,
  InputsDiv,
  Section,
  TextDiv,
  TwoBtns,
} from "../../styles/Common";
import { styled } from "styled-components";
import SlideModal from "../modal/SlideModal";
import { returnType } from "../hooks/basicFunc";
import { Modal, ReturnModal } from "../modal/Modal";
import { useDispatch, useSelector } from "react-redux";
import { getToken } from "../hooks/authFunc";
import { userActions } from "../../store/slices/userSlice";
import useDidMountEffect from "../hooks/useDidMountEffect";

const EditMyInfo = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const path = location.pathname;
  const urls = process.env.REACT_APP_BASE_URL;
  const [active, setActive] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [openEmailModal, setOpenEmailModal] = useState(false);
  const [openReturnModal, setOpenReturnModal] = useState(false);
  const [newEmail, setNewEmail] = useState("");
  const [emailStatus, setEmailStatus] = useState(false);
  const accessToken = getToken();
  const userInfo = useSelector((state) => state.user.userInfo);
  const changeUserEmailSuccess = useSelector(
    (state) => state.user.changeUserEmailSuccess
  );
  const changeUserNameSuccess = useSelector(
    (state) => state.user.changeUserNameSuccess
  );
  const changeUserPhoneSuccess = useSelector(
    (state) => state.user.changeUserPhoneSuccess
  );
  const modalMsg = useSelector((state) => state.user.modalMsg);
  const handleChangeInfo = (e) => {
    setActive(e.target.name);
    if (e.target.name == "email") {
      setOpenEmailModal(true);
    } else if (e.target.name == "password") {
      navigate("/mypage/edit/password");
    } else {
      setOpenConfirmModal(true);
    }
  };

  const handleSendEmail = () => {
    //이부분
    sessionStorage.setItem(
      "page",
      JSON.stringify({ path: path, option: active })
    );
    const params = {
      email: newEmail,
    };
    dispatch(userActions.fetchChangeUserEmail({ params, accessToken }));
  };

  useEffect(() => {
    if (changeUserEmailSuccess) {
      const timestamp = new Date().getTime();
      const params = {
        email: newEmail,
        timestamp: timestamp,
      };
      const loop = setInterval(() => {
        fetch(`${urls}/public/mail/url/verification`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ params }),
        })
          .then((response) => {
            // if (response.ok && response.status == 200) {
            if (response.status == 200) {
              setEmailStatus(true);
              clearInterval(loop);
            } else {
              setEmailStatus(false);
            }
          })
          .catch((err) => console.log(err));
      }, 5000);

      return () => clearInterval(loop);
    }
  }, [changeUserEmailSuccess]);

  useDidMountEffect(() => {
    if (emailStatus) {
      setOpenEmailModal(false);
      navigate("/mypage/edit/result", { state: { type: active } });
    }
  }, [emailStatus]);

  return (
    <Section className="minPaddingTop">
      {openReturnModal && (
        <ReturnModal
          setOpenModal={setOpenReturnModal}
          title="인증번호가 일치하지 않습니다!"
        ></ReturnModal>
      )}
      {openConfirmModal && (
        <SlideModal
          btnText={"본인인증"}
          setOpenModal={setOpenConfirmModal}
          closeModalFunc={() => setActive("")}
          callbackFunc={() => {
            sessionStorage.setItem(
              "page",
              JSON.stringify({ path: path, option: active })
            );
            window.open(`${urls}/danal/ready`, "_self", "fullscreen=yes");
            // 결과
            // navigate("/mypage/edit/result", { state: { type: active } });
          }}
          autoClose={true}
        >
          <Detail>
            <p>
              고객님의 {returnType(active)} 변경을 위해 <br />
              본인 인증이 필요합니다.
              <br />
              <br />
              지금 본인인증 하시겠습니까?
            </p>
          </Detail>
        </SlideModal>
      )}
      {openEmailModal && (
        <SlideModal
          btnText={"이메일 전송"}
          setOpenModal={setOpenEmailModal}
          closeModalFunc={() => {
            sessionStorage.removeItem("page");
            setActive("");
            setNewEmail("");
          }}
          callbackFunc={() => {
            handleSendEmail();
          }}
          autoClose={false}
        >
          <Detail>
            <p>변경할 이메일 주소를 입력해주세요.</p>
            <CurrentEamilDiv>
              <p>현재 이메일 주소</p>
              <CurrentEamil>{userInfo.email}</CurrentEamil>
            </CurrentEamilDiv>
            <EmailInput>
              <input
                type="email"
                placeholder="변경할 이메일 주소를 입력해주세요"
                name="email"
                value={newEmail || ""}
                onChange={(e) => {
                  setNewEmail(e.target.value);
                }}
                readOnly={changeUserEmailSuccess}
              />
            </EmailInput>
            <ul>
              <li> · 입력하신 이메일 주소로 인증 메일을 발송하였습니다.</li>
              <li>
                · 이메일 주소를 확인하여 이메일 인증하기 버튼을 클릭해 주세요.
              </li>
              <li> · 그후에 정상적으로 변경한 정보가 업데이트 됩니다.</li>
            </ul>
          </Detail>
        </SlideModal>
      )}

      <Content>
        <EditInfoTextDiv>
          <h3>뮤포인트 회원정보 수정</h3>
          {/* <p>
            이름, 비밀번호, 휴대폰번호,
            <br />
            이메일 주소 변경이 가능합니다.
          </p> */}
          <p>
            이름, 비밀번호,
            <br />
            이메일 주소 변경이 가능합니다.
          </p>
        </EditInfoTextDiv>
        <EditInfoInputsDiv>
          <div>
            <input type="text" placeholder={userInfo.name} readOnly />

            <ButtonXS
              col="purple_light"
              onClick={handleChangeInfo}
              name="name"
              className={active == "name" ? "active" : ""}
            >
              이름 변경
            </ButtonXS>
          </div>
          <div>
            <input type="email" placeholder={userInfo.email} readOnly />
            <ButtonXS
              col="purple_light"
              onClick={handleChangeInfo}
              name="email"
              className={active == "email" ? "active" : ""}
            >
              이메일 변경
            </ButtonXS>
          </div>
          <div>
            <input type="password" placeholder="*********" readOnly />
            <ButtonXS
              col="purple_light"
              onClick={handleChangeInfo}
              name="password"
              className={active == "password" ? "active" : ""}
            >
              비밀번호 변경
            </ButtonXS>
          </div>
          {/* <div>
            <input type="text" placeholder={userInfo.phone} readOnly />
            <ButtonXS
              col="purple_light"
              onClick={handleChangeInfo}
              name="phone"
              className={active == "phone" ? "active" : ""}
            >
              휴대폰번호 변경
            </ButtonXS>
          </div> */}
        </EditInfoInputsDiv>
      </Content>
      <TwoBtns>
        <Button
          onClick={
            changeUserNameSuccess || changeUserPhoneSuccess
              ? () => {
                  navigate(-4, { replace: true });
                }
              : () => {
                  navigate("/home");
                }
          }
        >
          취소
        </Button>
        <Button
          onClick={() => {
            navigate("/mypage/withdrawal");
          }}
        >
          회원탈퇴
        </Button>
      </TwoBtns>
    </Section>
  );
};

export default EditMyInfo;
const EditInfoTextDiv = styled(TextDiv)`
  p {
    margin-top: 1rem;
  }
`;
const EditInfoInputsDiv = styled(InputsDiv)`
  margin-top: 5rem;
  input {
    width: calc(100% - 14rem);
  }
  & > div {
    margin-top: 4rem;
    display: flex;
    justify-content: space-between;
  }
  .active {
    background-color: ${({ theme }) => theme.color.purple_dark};
  }
`;
const Detail = styled.div`
  margin-bottom: 5rem;
  ul {
    li {
      text-align: left;
      font-size: 1.2rem;
      font-weight: 400;
      line-height: 2rem; /* 166.667% */
      letter-spacing: -0.36px;
    }
  }
`;
const CurrentEamilDiv = styled.div`
  padding: 2rem 0;
  display: flex;
  justify-content: center;
  border-bottom: 1px dashed ${({ theme }) => theme.color.white};
  p {
    font-size: 1.4rem;
    font-weight: 800;
    line-height: 1.6rem; /* 114.286% */
  }
`;
const CurrentEamil = styled.p`
  margin-left: 2rem;
  color: ${({ theme }) => theme.color.yellow};
`;
const EmailInput = styled(InputsDiv)`
  padding: 3rem 0;
  input {
    background: rgba(255, 255, 255, 0.2);
    border-bottom: 1px solid #fff;
    padding: 0 1rem;
    color: ${({ theme }) => theme.color.white};
  }
  input::placeholder {
    color: ${({ theme }) => theme.color.input_text_purple};
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-text-fill-color: #ffffff;
    -webkit-box-shadow: 0 0 0px 1000px #9181f1 inset;
    box-shadow: 0 0 0px 1000px #9181f1 inset;
    transition: background-color 5000s ease-in-out 0s;
  }

  input:autofill,
  input:autofill:hover,
  input:autofill:focus,
  input:autofill:active {
    -webkit-text-fill-color: #ffffff;
    -webkit-box-shadow: 0 0 0px 1000px #9181f1 inset;
    box-shadow: 0 0 0px 1000px #9181f1 inset;
    transition: background-color 5000s ease-in-out 0s;
  }
`;
